export const NPM_DASHBOARD_VIEW_NEW = "new";
export const NPM_DASHBOARD_VIEW_CLASSIC = "classic";

export const NPM_DASHBOARD_STYLE_CARDS = "cards";
export const NPM_DASHBOARD_STYLE_ROWS = "rows";
